export default __webpack_public_path__ + "static/media/consort_diagram004A.218d1475.png";